/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const BoxIcon = /*#__PURE__*/ createSvgIcon(
  'BoxIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.559 2.5H17.44l1.059 8.469V17.5h-17v-6.531L2.559 2.5zm.882 1L2.5 11.031V16.5h15v-5.469L16.559 3.5H3.44z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.483 11.5H2v-1h5.346l.05.443a2.57 2.57 0 005.107 0l.051-.443H17.9v1h-4.483a3.571 3.571 0 01-6.934 0z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default BoxIcon;
